<template>
    <loading v-if="loading"></loading>
    <div class="component-school-groups includes-header" v-else>

        <header class="page-header school-groups-header">
            <h1>{{ school.name }}</h1>
            <p v-if="groups.length">Aan welke klassen geef je les?<br> Maak een nieuwe klas aan met de <strong>(+)</strong> knop</p>
            <p v-else>Er zijn nog geen klassen aangemaakt voor deze school. Maak een nieuwe klas aan met de <strong>(+)</strong> knop</p>
            <hr>
        </header>

        <ul class="school-groups" v-if="groups.length">
            <li class="school-groups__item" v-for="group in groups" :key="group.id" @click="addGroup(group, $event)">
                <h2 class="group-name" :class="{ active: isTeachingGroup(group) }">{{ group.name }}</h2>
            </li>
        </ul>

        <a href="#" @click.prevent="createGroup" class="button-rounded button-create button-create-group" ><span class="icon icon--add"></span>Nieuwe klas</a>

    </div>
</template>


<script>

import { transform, logreject } from 'js/vuex/helpers';
import api from  'js/api/resources';
import notify from 'js/components/notifications/notificationsMixin';
import track from 'js/helpers/analytics';

import PrimaryButton from 'js/components/elements/PrimaryButton.vue';
import Loading from 'js/components/elements/Loading.vue';

export default {
    name: 'SchoolGroups',
    mixins: [ notify ],
    components: { PrimaryButton, Loading  },
    data: function() {
        return {
            loading: false,
        }
    },
    vuex: {
        getters: {
            schools: state => state.users.current.schools.map( id => state.schools.storage[id] )
        },
        actions: {

            fetchGroupsForSchool: ({dispatch}, id) => {

                return api.getGroupsForSchool(id)
                    .then( response => {

                        let result = transform(response.body)
                        let groups = result.groups || []

                        dispatch('ADD_GROUPS', groups);
                        dispatch('SET_GROUPS_FOR_SCHOOL', groups.map( g => g.id), id)

                        return groups

                    })
                    .catch(error => logreject('Could not fetch groups', error))

            },

            storeGroupToTeacher: ({dispatch}, teacherId, groupId) => {

                return api.addGroupToTeacher(teacherId, groupId, true)
                    .then( response => {
                        let result = transform(response.body)
                        let groups = result.groups || []

                        dispatch('ADD_TERMS', result.terms || [])
                        dispatch('ADD_PERIODS', result.periods || [])
                        dispatch('ADD_GROUPS', groups);
                        dispatch('ADD_GROUP_TERMS', result.groupterms || [])
                        dispatch('ADD_GROUP_PERIODS', result.groupperiods || [])
                        dispatch('SET_CURRENT_USER_GROUPS', groups.map( g => g.id) )

                    })
            },

            createGroup: ({dispatch}) => {
                dispatch('SHOW_MODAL', 'GroupSettings')
            },

        }
    },
    methods: {
        addGroup: function(group, e) {
            e.stopPropagation()

            if ( this.isTeachingGroup(group) ) {
                this.$warn('Deze klas is al toegevoegd')
                return
            }

            this.$alert('Weet je zeker dat je klas ' + group.name + ' wilt toevoegen aan jouw overzicht?', [
                { name: 'Annuleren' },
                { name: 'Toevoegen', primary: true, action: () => {

                    this.storeGroupToTeacher( this.$store.state.users.current.id, group.id )
                        .then( () => {
                            this.$success('Klas ' + group.name  + ' toegevoegd')
                            this.$emit('close')
                        })
                        .catch( err => {
                            track.exception('Can\'t add group to teacher', err)
                            this.$warn('Kan klas niet toevoegen')
                        })

                }}

            ])

        },
        isTeachingGroup: function(group) {
            return this.$store.state.users.current.groups.indexOf(group.id) !== -1
        }
    },
    computed: {

        school: function() {
            return this.schools[0]
        },
        groups: function() {
            return this.school.groups.map( id => this.$store.state.groups.storage[id])
        }

    },
    created: function() {

        this.loading = true

        this.fetchGroupsForSchool( this.school.id )
            .then( () => this.loading = false)
            .then( () => {
                if (this.groups.length === 0) {
                    this.createGroup()
                }
            })
            .catch( err => {
                track.exception('Can\'t load school groups', err)
                this.$error('Kan klassen niet laden.')
            })

    }
}
</script>


<style lang="scss">

    @import 'global';

    .school-groups {
        list-style-type: none;
        padding: 1em;
        text-align: center;
    }

    .school-groups__item {

        cursor: pointer;
        display: inline-block;
        padding: 0.7em 2em;

        &:hover {
            .group-name {
                transform: translateY(-5px);
            }
        }

        .group-name {
            transition: transform 0.2s ease-out;
            margin: 0;

            &.active {
                color: $color-primary;
            }

        }

    }

    .button-create-group {
        display: block;
        margin: 0 auto;
    }

</style>



// WEBPACK FOOTER //
// School.vue?59df0d6a